import { createStore } from "zustand/vanilla";
import { createBoundedUseStore } from "./usestore";

type SnackBar = {
  isOpen: boolean;
  message: string;
  severity: "success" | "info" | "warning" | "error";
};

interface SnackBarState {
  snackBar: SnackBar;
  getSnackBar: () => SnackBar;
  setSnackBar: (
    isOpen: boolean,
    message?: string,
    severity?: "success" | "info" | "warning" | "error"
  ) => void;
}

export const snackBarStore = createStore<SnackBarState>()((set, get) => ({
  snackBar: {
    isOpen: false,
    message: "",
    severity: "info",
  },
  getSnackBar: () => {
    return get().snackBar;
  },
  setSnackBar: (
    isOpen: boolean,
    message?: string,
    severity?: "success" | "info" | "warning" | "error"
  ) => {
    set(() => ({
      snackBar: {
        isOpen,
        message: message || "",
        severity: severity || "info",
      },
    }));
  },
}));

const useSnackBarStore = createBoundedUseStore(snackBarStore);
export default useSnackBarStore;
